import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const saveExpertise = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.PROFESSIONAL.SAVE_EXPERTISE,
      method: 'put',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}